import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

export type InquiryAssignMember = {
  id: number
  employeeNumber: number | null
  name: string
  divisionId: number | null
  divisionName: string | null
  shortDivisionName: string | null
  roleId: number | null
  roleName: string | null
  unitPrice: number | null
  employeeTypeId: number | null
  employeeTypeName: string | null
}

type GetInquiryAssignMembersResponse = {
  total: number
  members: InquiryAssignMember[]
}

interface UseInquiryAssignMembersParams {
  inquiryId?: number | null
  startOn?: string
  endOn?: string
}

export function useInquiryAssignMembers({ inquiryId, startOn, endOn }: UseInquiryAssignMembersParams = {}) {
  return useQuery({
    queryKey: queryKeys.inquiry.assignMembers.list({
      inquiryId: inquiryId ?? null,
      startOn: startOn ?? null,
      endOn: endOn ?? null,
    }),
    queryFn: () => {
      const params = new URLSearchParams({ limit: '1000' })
      if (inquiryId != null) params.append('inquiryId', String(inquiryId))
      if (startOn) params.append('startOn', startOn)
      if (endOn) params.append('endOn', endOn)

      return apiFetch<GetInquiryAssignMembersResponse>(`/api/inquiry-assign-members?${params.toString()}`, {
        method: 'GET',
      })
    },
    staleTime: 60 * 60 * 1000,
  })
}
